/**
 * assets/addon-picker.js
 *
 * Handles the add-on pills rendered by snippets/addon-picker.liquid,
 * and intercepts the product form's "Add to cart" submit so the main
 * item + every selected add-on go into the cart together as separate
 * line items (separate inventory, no variant coupling).
 */

document.addEventListener('DOMContentLoaded', function () {
  const picker = document.querySelector('[data-addon-picker]');
  if (!picker) return;

  // --- Add-on selection state -------------------------------------------
  const selectedAddons = new Map();

  picker.querySelectorAll('[data-addon-item]').forEach(function (item) {
    const title = item.getAttribute('data-title');
    const toggleBtn = item.querySelector('[data-addon-toggle]');
    const toggleLabel = item.querySelector('[data-addon-toggle-label]');
    const stepper = item.querySelector('[data-addon-stepper]');
    const qtyEl = item.querySelector('[data-addon-qty]');
    const incBtn = item.querySelector('[data-addon-increment]');
    const decBtn = item.querySelector('[data-addon-decrement]');
    const removeBtn = item.querySelector('[data-addon-remove]');
    const variantSelect = item.querySelector('[data-addon-variant-select]');

    function getVariantId() { return item.getAttribute('data-variant-id'); }
    function getUnitPrice() { return parseInt(item.getAttribute('data-unit-price'), 10) || 0; }

    function select() {
      const variantId = getVariantId();
      selectedAddons.set(variantId, { quantity: 1, title, unitPrice: getUnitPrice() });
      qtyEl.textContent = '1';
      toggleBtn.style.setProperty('display', 'none', 'important');
      toggleBtn.setAttribute('aria-pressed', 'true');
      stepper.hidden = false;
    }

    function deselect() {
      selectedAddons.delete(getVariantId());
      toggleBtn.style.removeProperty('display');
      toggleBtn.setAttribute('aria-pressed', 'false');
      stepper.hidden = true;
    }

    function setQty(newQty) {
      if (newQty < 1) { deselect(); return; }
      qtyEl.textContent = String(newQty);
      const entry = selectedAddons.get(getVariantId());
      if (entry) entry.quantity = newQty;
    }

    toggleBtn.addEventListener('click', select);
    removeBtn.addEventListener('click', deselect);
    incBtn.addEventListener('click', function () { setQty((parseInt(qtyEl.textContent, 10) || 1) + 1); });
    decBtn.addEventListener('click', function () { setQty((parseInt(qtyEl.textContent, 10) || 1) - 1); });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const oldVariantId = getVariantId();
        const chosen = variantSelect.selectedOptions[0];
        const newVariantId = chosen.value;
        const newPrice = parseInt(chosen.getAttribute('data-price'), 10) || 0;
        const wasSelected = selectedAddons.has(oldVariantId);
        const currentQty = wasSelected ? selectedAddons.get(oldVariantId).quantity : 1;

        item.setAttribute('data-variant-id', newVariantId);
        item.setAttribute('data-unit-price', newPrice);
        if (toggleLabel) toggleLabel.textContent = title + ' — ' + chosen.textContent.trim();

        if (wasSelected) {
          selectedAddons.delete(oldVariantId);
          selectedAddons.set(newVariantId, { quantity: currentQty, title, unitPrice: newPrice });
        }
      });
    }
  });

  // --- Find the product form and wire up submit ---------------------------
  let productForm = null;
document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
    if (f.querySelector('[name="add"]')) productForm = f;
  });
  if (!productForm) {
    console.warn('addon-picker.js: could not find the product add-to-cart form.');
    return;
  }

  // --- Intercept the main "Add to cart" submit ---------------------------
  productForm.addEventListener('submit', function (event) {
    event.preventDefault();

    const formData = new FormData(productForm);
    const mainVariantId = formData.get('id');
    const mainQty = parseInt(formData.get('quantity'), 10) || 1;

    const items = [{ id: mainVariantId, quantity: mainQty }];

    selectedAddons.forEach(function (entry, variantId) {
      items.push({ id: variantId, quantity: entry.quantity });
    });

    const submitBtn = productForm.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (err) { throw err; });
        return response.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('addon-picker.js: add to cart failed', err);
        alert(err.description || 'Something went wrong adding items to your cart. Please try again.');
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
});